(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["word-request-form"] && !Shopify.designMode) return;
  try {
    // 「新しいことばの作成依頼」フォームの JS 強化。JS 無しでも通常の POST で送れる(上のコメント参照)。
  // sections/product.liquid の「デザインの改善要望フォーム」と同じ振る舞い。
  // このブロックは全ページの snippet-scripts.js に集約されるが、[data-word-request] が無いページでは何もしない。
  (() => {
    const TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    let turnstileLoading;

    function loadTurnstile() {
      if (window.turnstile) return Promise.resolve(window.turnstile);
      if (!turnstileLoading) {
        turnstileLoading = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = TURNSTILE_SRC;
          script.async = true;
          script.onload = () => resolve(window.turnstile);
          script.onerror = (error) => {
            // 失敗した Promise を残すと二度と読み直さないので捨てる（次に開いたときに再試行する）
            turnstileLoading = undefined;
            script.remove();
            reject(error);
          };
          document.head.appendChild(script);
        });
      }
      return turnstileLoading;
    }

    function showStatus(id) {
      document.querySelectorAll('.word-request__status').forEach((el) => {
        el.classList.toggle('is-visible', el.id === id);
      });
      const el = id && document.getElementById(id);
      if (el) el.focus();
    }

    const PHRASE_NOTE = '28字まで。';
    const PHRASE_NOTE_TOO_LONG = '検索したことばは28字をこえているので、入れていません。28字までで書いてください。';
    const PHRASE_MAX = 28;

    // ページ内検索(ことば一覧・TOP)から呼ぶ入口。フォームは1ページに1つだけ
    let api;

    function init() {
      document.querySelectorAll('[data-word-request]').forEach((details) => {
        const root = details.closest('[data-word-request-root]');
        const form = details.querySelector('[data-word-request-form]');
        const slot = form.querySelector('[data-turnstile]');
        const button = form.querySelector('button[type="submit"]');
        const sitekey = form.dataset.turnstileSitekey;
        const phraseInput = form.querySelector('input[name="phrase"]');
        const phraseNote = form.querySelector('[data-word-request-phrase-note]');
        const termsInput = form.querySelector('input[name="search_terms"]');
        // ページ内検索のあとに JS が出すフォーム(deferred)は、最初 hidden で描画されている
        const deferred = Boolean(root && root.hidden);
        let widgetId;
        let terms = '';
        let phraseEdited = false;

        // 検索語を初期値に入れる。本人が書き換えたあとは上書きしない
        function applyTerms() {
          termsInput.value = terms.slice(0, 200);
          if (phraseEdited) return;
          const tooLong = terms.length > PHRASE_MAX;
          phraseInput.value = tooLong ? '' : terms;
          if (phraseNote) phraseNote.textContent = tooLong ? PHRASE_NOTE_TOO_LONG : PHRASE_NOTE;
        }

        phraseInput.addEventListener('input', () => {
          phraseEdited = true;
        });

        if (deferred) {
          api = {
            show(q) {
              terms = q;
              root.hidden = false;
              // 新しい検索なので、前回の送信結果の一文は消す
              showStatus(null);
              applyTerms();
            },
            hide() {
              root.hidden = true;
              showStatus(null);
            },
          };
        }

        // 開いたときに初めて Turnstile を読む。読めなくてもトークン無しで送れる(Worker が厳しめに制限する)
        details.addEventListener('toggle', () => {
          if (!details.open || !sitekey || widgetId !== undefined) return;
          widgetId = null;
          loadTurnstile()
            .then((turnstile) => {
              // 既定の normal は 300px 固定なので、それより狭い画面では compact(150px)にする。
              // slot 自体は空のうち display: none で幅 0 なので、フォームの幅で判定する
              const size = form.clientWidth < 300 ? 'compact' : 'normal';
              widgetId = turnstile.render(slot, { sitekey, size, theme: 'light' });
            })
            .catch(() => {
              // 読めなくてもトークン無しで送れる。次に開いたときにもう一度読みにいけるよう戻す
              widgetId = undefined;
            });
        });

        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          button.disabled = true;
          try {
            const res = await fetch(form.action, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: new URLSearchParams(new FormData(form)),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok || !data.ok) throw new Error(data.error || String(res.status));
            form.reset();
            // reset で初期値に戻るので、ページ内検索用は現在の検索語を入れ直す(/search は初期値のままでよい)
            if (deferred) {
              phraseEdited = false;
              applyTerms();
            }
            details.open = false;
            showStatus('word-request-sent');
          } catch (error) {
            showStatus('word-request-error');
          } finally {
            button.disabled = false;
            if (widgetId && window.turnstile) window.turnstile.reset(widgetId);
          }
        });
      });

    }

    // snippet-scripts.js は head で読まれ、この時点では DOM が未構築のことがあるので、揃ってから結びつける
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    // ページ内検索のコールバックは init 前後どちらでも呼べるよう、入口は先に生やしておく
    window.diarywordsWordRequest = {
      show: (q) => api && api.show(q),
      hide: () => api && api.hide(),
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
